import { Injectable, OnDestroy, inject } from '@angular/core';
import { GatewayApi } from '../api/gateway.api';
import { Observable, Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { Gateway } from 'src/utils/models/gateway.model';
import { arrayToMap, StorageV2Service, StoreV2Map } from '@schenck/rotec-components';

@Injectable()
export class GatewayService extends StoreV2Map<Gateway> implements OnDestroy {
  private readonly gatewayApi = inject(GatewayApi);

  private onDestroy$ = new Subject<void>();
  constructor() {
    const storageService = inject(StorageV2Service);

    super('GatewayService', { storageService, name: 'GatewayService' });
  }

  public loadGateways$(serial: string): Observable<string[]> {
    return this.gatewayApi.get$(serial).pipe(takeUntil(this.onDestroy$));
  }

  public getGatewayInfo$(serial: string): Observable<Gateway> {
    return this.gatewayApi.getGatewayInfo$(serial).pipe(
      takeUntil(this.onDestroy$),
      tap((data) => {
        this.setState('got all info about gateway', arrayToMap([data], 'serial'));
      })
    );
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
